import React, { useState } from 'react';

import {
  useTeeSheetCreatorDispatch,
  useTeeSheetCreatorState
} from '../../Context/TeeSheetCreator.context';
import { filter } from '../../Utils/filter';
import { filters } from '../../Utils/filters';
import { removeGrouped } from '../../Utils/removeGrouped';
import AddGuestPlayerPopOver from '../AddGuestPlayerPopOver/AddGuestPlayerPopOver';
import PlayerCard from '../../../../../../components/PlayerCard/PlayerCard';
import { useRouteInfoState } from '../../../../../../components/RouteInfo/Context/RouteInfo.context';
import Input from '../../../../../../components/Input';
import { useAdminRound } from '../../../../../../contrib/Hooks/useAdminRound.hook';
import { useGetAdminEvent } from '../../../../../../contrib/Hooks/useGetAdminEvent';
import DraggableList from '../../../../../../components/Lists/DraggableList/DraggableList';
import { playerSelectorDroppableId } from './Utils/playerSelectorDroppableId';

export const PlayerSelector = () => {
  const { selectedGroup, selectedSwap, selectedPlayer } = useTeeSheetCreatorState();

  const {
    actions: { onSelectPlayerToAdd, onPlayerSwap }
  } = useTeeSheetCreatorDispatch();

  const { roundId, eventId } = useRouteInfoState();

  const [round] = useAdminRound(roundId);

  const event = useGetAdminEvent(eventId);

  const currentGroups = round && round.groups ? round.groups : [];

  const availablePlayers = removeGrouped(round ? round.enrollments : [], currentGroups);

  const [searchValue, setSearchValue] = useState('');

  const onSearchChange = (e: any) => {
    setSearchValue(e.target.value);
  };

  return (
    <div className="left">
      {event && <AddGuestPlayerPopOver />}

      <Input
        id="player-lookup"
        label="PLAYER LOOKUP"
        onChange={onSearchChange}
        outlined={true}
        placeholder="PLAYER LOOKUP"
        type="search"
        value={searchValue}
      />

      <DraggableList
        droppableId={playerSelectorDroppableId}
        items={availablePlayers}
        renderItem={PlayerCard}
        filters={filters}
        customFilter={filter(searchValue)}
        context={{
          isSelectable: !!selectedGroup,
          isSwapable: !!selectedSwap,
          onAddClick: !!selectedGroup ? onSelectPlayerToAdd : undefined,
          onAddPlayer: onSelectPlayerToAdd,
          onSwapPlayer: onPlayerSwap,
          round,
          swappingInProcess: selectedPlayer > 0,
          type: 'player'
        }}
      />
    </div>
  );
};
